"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfficeThemeSupplementalFontSchemeDestination = void 0;
var tslib_1 = require("tslib");
var string_1 = require("@devexpress/utils/lib/utils/string");
var destination_1 = require("../../destination");
var OfficeThemeSupplementalFontSchemeDestination = (function (_super) {
    tslib_1.__extends(OfficeThemeSupplementalFontSchemeDestination, _super);
    function OfficeThemeSupplementalFontSchemeDestination(data, fontPart) {
        var _this = _super.call(this, data) || this;
        _this.fontPart = fontPart;
        return _this;
    }
    OfficeThemeSupplementalFontSchemeDestination.prototype.processElementClose = function (reader) {
        var script = this.data.readerHelper.readAttribute(reader, 'script');
        var typeface = this.data.readerHelper.readAttribute(reader, 'typeface');
        if (string_1.StringUtils.isNullOrEmpty(script) && string_1.StringUtils.isNullOrEmpty(typeface))
            this.data.options.throwInvalidFile('Invalid fonts');
        this.fontPart.addSupplementalFont(script, typeface);
    };
    return OfficeThemeSupplementalFontSchemeDestination;
}(destination_1.LeafElementDestination));
exports.OfficeThemeSupplementalFontSchemeDestination = OfficeThemeSupplementalFontSchemeDestination;
